import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionRole, ProtegusUserData } from 'src/api/v3/common';
import { LanguageAware } from 'src/app/general/language-aware';
import { TEditableComponent } from 'src/app/models/editable-component';
import { EditSystemService } from 'src/app/services/edit-system.service';

@Component({
  selector: 'app-owner-privacy',
  templateUrl: './owner-privacy.component.html',
  styleUrls: ['./owner-privacy.component.scss'],
})
export class OwnerPrivacyComponent extends LanguageAware implements OnInit {
  public localUser: ProtegusUserData;
  public privacySettings: any;

  constructor(cdRef: ChangeDetectorRef, private es: EditSystemService, private router: Router) {
    super(cdRef);
    this.localUser = this.es.getEditableComponent(TEditableComponent.User);
    if (this.localUser === null || (this.us.currentUser.permissions?.role !== PermissionRole.SuperAdmin && this.us.currentUser.id !== this.localUser.id)) {
      this.router.navigate(this.g.getHomeUrl());
      return;
    }
    this.background.setGray();
    this.headerBar.showHeader({
      headerText: this.trans('users.labels.privacySettings'),
      backUrl: '*',
    });
    this.privacySettings = this.systems.activeSystem.privacyOfOwners.find((p) => p.user_id === this.localUser.id);
    this.es.beginComponentEdit(TEditableComponent.OwnerPrivacy, this.localUser.id, this.privacySettings);
    if (this.privacySettings === undefined) {
      this.privacySettings = {
        user_id: this.localUser.id,
        system_id: this.systems.activeSystem.id,
        show_email_admins: true,
        show_name_admins: true,
        show_phone_admins: true,
        show_email_users: true,
        show_name_users: true,
        show_phone_users: true,
      };
    }
    this.footerBar.showFooter(this.trans('general.cancel'), this.trans('general.save'), true, false);
    this.footerBar.onButton1Click = () => {
      history.back();
    };
    this.footerBar.onButton2Click = () => {
      this.doSave();
    };
  }

  ngOnInit(): void {}

  private doSave() {
    const before = this.es.getComponentBeforeModification(TEditableComponent.OwnerPrivacy);
    const userId = this.localUser.id;
    const systemId = this.systems.activeSystem.id;
    if (before === null) {
      this.systems.activeSystem.privacyOfOwners.push(this.privacySettings);
    }
    this.api.post('/owner-privacy', {
      user_id: userId,
      system_id: systemId,
      privacy_settings: this.privacySettings,
    }, true).subscribe(
      (result) => {
        if (!result.success) {
          this.toaster.postError(result.error);
          this.revertChanges(userId, systemId, before);
        }
      },
      (error) => {
        this.revertChanges(userId, systemId, before);
      }
    );
    history.back();
  }

  private revertChanges(userId: number, systemId: number, before: any) {
    const system = this.systems.getSystem(systemId);
    if (system === undefined) {
      return;
    }
    const privacySetting = system.privacyOfOwners.find((p) => (p.user_id = userId));
    if (privacySetting === undefined && before !== null) {
      system.privacyOfOwners.push(before);
    } else if (privacySetting !== undefined && before === null) {
      system.privacyOfOwners = system.privacyOfOwners.filter((p) => p.user_id !== userId);
    } else if (privacySetting !== undefined && before !== null) {
      privacySetting.show_email_admins = before.show_email_admins;
      privacySetting.show_name_admins = before.show_name_admins;
      privacySetting.show_phone_admins = before.show_phone_admins;
      privacySetting.show_email_users = before.show_email_users;
      privacySetting.show_name_users = before.show_name_users;
      privacySetting.show_phone_users = before.show_phone_users;
    }
  }
}
